import { TranslatedString } from "@gnu-taler/taler-util";
import { VNode, h } from "preact";
import { RenderAddon } from "./InputLine.js";
import { Addon, resolveFieldHandler, UIFormProps } from "../FormProvider.js";

interface Props {
  label: TranslatedString;
  url: string;
  media?: string;
  tooltip?: TranslatedString;
  help?: TranslatedString;
  before?: Addon;
  after?: Addon;
}

export function ExternalLink({
  before,
  after,
  label,
  url,
  media,
  tooltip,
  handler,
  name,
  help,
  required,
  disabled,
}: Props & UIFormProps<boolean>): VNode {
  const { onChange, error } = resolveFieldHandler(handler, name);
  return (
    <div class="sm:col-span-6">
      {before !== undefined && <RenderAddon addon={before} />}
      <a
        href={url}
        class="underline text-blue-600 hover:text-blue-900 visited:text-purple-600"
        target="_blank"
        rel="noreferrer"
        aria-disabled={disabled}
        onClick={(event) => {
          if (disabled) {
            event.preventDefault();
            return;
          }
          onChange(true);
        }}
      >
        {label}
      </a>
      {required && (
        <span class="text-xl bold leading-6 text-red-600 pl-2">*</span>
      )}
      {after !== undefined && <RenderAddon addon={after} />}
      {help && (
        <p class="mt-2 text-sm text-gray-500" id="email-description">
          {help}
        </p>
      )}
      {error && <p class="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
